// import React, { useRef, useEffect, useState } from "react";
// import { calculateScratchPercentage } from "../earningWallet.utils";

// interface ScratchCardProps {
//   width?: number;
//   height?: number;
//   image?: string;
//   finishPercent?: number;
//   onComplete?: () => void;
//   brushSize?: number;
//   children: React.ReactNode;
// }

// export const ScratchCard: React.FC<ScratchCardProps> = ({
//   width = 320,
//   height = 256,
//   image,
//   finishPercent = 70,
//   onComplete,
//   brushSize = 20,
//   children,
// }) => {
//   const canvasRef = useRef<HTMLCanvasElement>(null);
//   const [isRevealed, setIsRevealed] = useState(false);

//   const [isDrawing, setIsDrawing] = useState(false);
//   const [lastPoint, setLastPoint] = useState<{ x: number; y: number } | null>(
//     null
//   );

//   useEffect(() => {
//     const canvas = canvasRef.current;
//     if (!canvas) return;

//     const ctx = canvas.getContext("2d");
//     if (!ctx) return;

//     // Set canvas scale for retina displays
//     const scale = window.devicePixelRatio || 1;
//     canvas.width = width * scale;
//     canvas.height = height * scale;
//     canvas.style.width = `${width}px`;
//     canvas.style.height = `${height}px`;
//     ctx.scale(scale, scale);

//     if (image) {
//       const img = new Image();
//       img.crossOrigin = "anonymous";
//       img.onload = () => {
//         ctx.drawImage(img, 0, 0, width, height);
//       };
//       img.src = image;
//     } else {
//       // Create gradient overlay
//       const gradient = ctx.createLinearGradient(0, 0, width, height);
//       gradient.addColorStop(0, "#888888");
//       gradient.addColorStop(1, "#666666");
//       ctx.fillStyle = gradient;
//       ctx.fillRect(0, 0, width, height);
//     }
//   }, [width, height, image]);

//   const getCoordinates = (
//     event: MouseEvent | TouchEvent
//   ): { x: number; y: number } | null => {
//     const canvas = canvasRef.current;
//     if (!canvas) return null;

//     const rect = canvas.getBoundingClientRect();
//     const scale = window.devicePixelRatio || 1;

//     let clientX, clientY;
//     if (event instanceof MouseEvent) {
//       clientX = event.clientX;
//       clientY = event.clientY;
//     } else {
//       clientX = event.touches[0].clientX;
//       clientY = event.touches[0].clientY;
//     }

//     return {
//       x: (clientX - rect.left) * (canvas.width / (rect.width * scale)),
//       y: (clientY - rect.top) * (canvas.height / (rect.height * scale)),
//     };
//   };

//   const scratch = (point: { x: number; y: number }) => {
//     const canvas = canvasRef.current;
//     const ctx = canvas?.getContext("2d");
//     if (!ctx || !canvas || !lastPoint) return;

//     ctx.globalCompositeOperation = "destination-out";
//     ctx.lineWidth = brushSize;
//     ctx.lineCap = "round";
//     ctx.lineJoin = "round";
//     ctx.beginPath();
//     ctx.moveTo(lastPoint.x, lastPoint.y);
//     ctx.lineTo(point.x, point.y);
//     ctx.stroke();

//     // Check scratch percentage
//     const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
//     const scratchedPercent = calculateScratchPercentage(imageData);

//     if (scratchedPercent >= finishPercent && !isRevealed) {
//       setIsRevealed(true);
//       onComplete && onComplete();
//     }
//   };

//   const handleStart = (event: React.MouseEvent | React.TouchEvent) => {
//     event.preventDefault();
//     const point = getCoordinates(event.nativeEvent);
//     if (!point) return;

//     setIsDrawing(true);
//     setLastPoint(point);
//   };

//   const handleMove = (event: React.MouseEvent | React.TouchEvent) => {
//     event.preventDefault();
//     if (!isDrawing) return;

//     const point = getCoordinates(event.nativeEvent);
//     if (!point) return;

//     scratch(point);
//     setLastPoint(point);
//   };

//   const handleEnd = () => {
//     setIsDrawing(false);
//     setLastPoint(null);
//   };

//   return (
//     <div className="relative select-none" style={{ width, height }}>
//       <div
//         className="absolute inset-0 flex items-center justify-center rounded-lg overflow-hidden"
//         style={{ width, height }}
//       >
//         {children}
//       </div>

//       <canvas
//         ref={canvasRef}
//         style={{ width, height }}
//         className={`absolute top-0 left-0 rounded-lg cursor-pointer touch-none ${
//           isRevealed ? "hidden" : ""
//         }`}
//         onMouseDown={handleStart}
//         onMouseMove={handleMove}
//         onMouseUp={handleEnd}
//         onMouseLeave={handleEnd}
//         onTouchStart={handleStart}
//         onTouchMove={handleMove}
//         onTouchEnd={handleEnd}
//       />
//     </div>
//   );
// };

import React, { useRef, useEffect, useState } from "react";
import { calculateScratchPercentage } from "../earningWallet.utils";

interface ScratchCardProps {
  width?: number;
  height?: number;
  image?: string;
  finishPercent?: number;
  onComplete?: () => void;
  brushSize?: number;
  children: React.ReactNode;
}

export const ScratchCard: React.FC<ScratchCardProps> = ({
  width = 320,
  height = 256,
  image,
  finishPercent = 70,
  onComplete,
  brushSize = 20,
  children,
}) => {
  const canvasRef = useRef<HTMLCanvasElement>(null);
  const [isRevealed, setIsRevealed] = useState(false);
  const onCompleteCalled = useRef(false); // Track if onComplete has been called

  const [isDrawing, setIsDrawing] = useState(false);
  const [lastPoint, setLastPoint] = useState<{ x: number; y: number } | null>(
    null
  );

  useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas) return;

    const ctx = canvas.getContext("2d");
    if (!ctx) return;

    // Set canvas scale for retina displays
    const scale = window.devicePixelRatio || 1;
    canvas.width = width * scale;
    canvas.height = height * scale;
    canvas.style.width = `${width}px`;
    canvas.style.height = `${height}px`;
    ctx.scale(scale, scale);

    if (image) {
      const img = new Image();
      img.crossOrigin = "anonymous";
      img.onload = () => {
        ctx.drawImage(img, 0, 0, width, height);
      };
      img.src = image;
    } else {
      // Create gradient overlay
      const gradient = ctx.createLinearGradient(0, 0, width, height);
      gradient.addColorStop(0, "#888888");
      gradient.addColorStop(1, "#666666");
      ctx.fillStyle = gradient;
      ctx.fillRect(0, 0, width, height);
    }
  }, [width, height, image]);

  const getCoordinates = (
    event: MouseEvent | TouchEvent
  ): { x: number; y: number } | null => {
    const canvas = canvasRef.current;
    if (!canvas) return null;

    const rect = canvas.getBoundingClientRect();
    const scale = window.devicePixelRatio || 1;

    let clientX, clientY;
    if (event instanceof MouseEvent) {
      clientX = event.clientX;
      clientY = event.clientY;
    } else {
      clientX = event.touches[0].clientX;
      clientY = event.touches[0].clientY;
    }

    return {
      x: (clientX - rect.left) * (canvas.width / (rect.width * scale)),
      y: (clientY - rect.top) * (canvas.height / (rect.height * scale)),
    };
  };

  const scratch = (point: { x: number; y: number }) => {
    const canvas = canvasRef.current;
    const ctx = canvas?.getContext("2d");
    if (!ctx || !canvas || !lastPoint) return;

    ctx.globalCompositeOperation = "destination-out";
    ctx.lineWidth = brushSize;
    ctx.lineCap = "round";
    ctx.lineJoin = "round";
    ctx.beginPath();
    ctx.moveTo(lastPoint.x, lastPoint.y);
    ctx.lineTo(point.x, point.y);
    ctx.stroke();

    // Check scratch percentage
    const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
    const scratchedPercent = calculateScratchPercentage(imageData);

    if (scratchedPercent >= finishPercent && !isRevealed) {
      setIsRevealed(true);
      if (!onCompleteCalled.current) {
        onCompleteCalled.current = true;
        onComplete?.();
      }
    }
  };

  const handleStart = (event: React.MouseEvent | React.TouchEvent) => {
    event.preventDefault();
    const point = getCoordinates(event.nativeEvent);
    if (!point) return;

    setIsDrawing(true);
    setLastPoint(point);
  };

  const handleMove = (event: React.MouseEvent | React.TouchEvent) => {
    event.preventDefault();
    if (!isDrawing) return;

    const point = getCoordinates(event.nativeEvent);
    if (!point) return;

    scratch(point);
    setLastPoint(point);
  };

  const handleEnd = () => {
    setIsDrawing(false);
    setLastPoint(null);
  };

  return (
    <div className="relative select-none" style={{ width, height }}>
      <div
        className="absolute inset-0 flex items-center justify-center rounded-lg overflow-hidden"
        style={{ width, height }}
      >
        {children}
      </div>

      <canvas
        ref={canvasRef}
        style={{ width, height }}
        className={`absolute top-0 left-0 rounded-lg cursor-pointer touch-none ${
          isRevealed ? "hidden" : ""
        }`}
        onMouseDown={handleStart}
        onMouseMove={handleMove}
        onMouseUp={handleEnd}
        onMouseLeave={handleEnd}
        onTouchStart={handleStart}
        onTouchMove={handleMove}
        onTouchEnd={handleEnd}
      />
    </div>
  );
};
